import React from 'react';
import { useHistory } from 'react-router-dom';
import { appRoutes } from '../../../routes/routes';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { SalesforceCard } from './SalesforceCard.component';
import styles from './SalesforceDetailPage.module.scss';

export const SalesforceDetailPage = () => {
  const history = useHistory();

  return (
    <div className={styles.page}>
      <button
        className={styles.backBtn}
        onClick={() => history.push(appRoutes().integrations)}
      >
        ← Back to Integrations
      </button>

      <div className={styles.pageHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.logoMark}>SF</div>
          <div className={styles.titleBlock}>
            <Text
              variant={textVariantsEnum.Header}
              fontWeight={fontWeightEnum.Semibold}
            >
              Salesforce
            </Text>
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Normal}
              color="gray-600"
            >
              Sync Prodaff employees to Salesforce Contacts for unified
              workforce visibility.
            </Text>
          </div>
        </div>
      </div>

      <div className={styles.panels}>
        <SalesforceCard />
      </div>
    </div>
  );
};
